export { default } from './AdminUsers.container'



// WEBPACK FOOTER //
// ./src/pages/AdminUsers/index.js